import axios from 'axios';
/**
 * Вероятнее всего ошибка axios
 * @param {Error} error
 * @return {boolean}
 */
export var isAxiosError = function (error) {
    if (axios.isAxiosError(error)) {
        return true;
    }
    if (!(error instanceof Error)) {
        return false;
    }
    return 'config' in error && 'request' in error && 'response' in error;
};
